import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./ConfirmMessage.module.css";

import BidProPlusBiddingLogo from "../../assets/BidProPlusBiddingLogo.png";
import BidProPlusSeniorityLogo from "../../assets/BidProPlusSeniorityLogo.png";
import BidProPlusTripBoardLogo from "../../assets/BidProPlusTripBoardLogo.png";

const ConfirmationMessage = ({
  product,
  imageSrc,
  price,
  cycle,
  features,
  onContinue,
  onCancel,
}) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showError, setShowError] = useState(false);

  const handleTermsToggle = () => {
    setTermsAccepted(!termsAccepted);
    setShowError(false);
  };

  const handleContinueClick = () => {
    if (!termsAccepted) {
      setShowError(true); // Show error message if the checkbox is not checked
      return;
    }
    onContinue();
  };
  const imageMapping = {
    "BidProPlusBiddingLogo.png": BidProPlusBiddingLogo,
    "BidProPlusSeniorityLogo.png": BidProPlusSeniorityLogo,
    "BidProPlusTripBoardLogo.png": BidProPlusTripBoardLogo,
  };
  const mappedImages = imageSrc.map((src) => imageMapping[src] || src);

  //const matchedImage = imageMapping[imageSrc] || "";

  return (
    <div className="container mt-5">
      <form className="needs-validation" noValidate>
        <div className="row justify-content-center mt-3">
          <div className="col-12">
            <h5 className="text-center">
              Verify sub type and accept Ts & Cs...
            </h5>
          </div>
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-12">
            <p className={styles.header}>
              Verify your subscription below, accept the terms and conditions,
              <br />
              then click <b>Next</b> to enter payment information.
            </p>
          </div>
        </div>

        <div className="row justify-content-center mt-3">
          <div
            className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5"
            style={{ minWidth: "320px" }}
          >
            <div className="card round-it">
              <div className="card-header text-center bg-dark text-white">
                Single App
              </div>
              <div className="card-body text-center">
                <div className={styles.imageContainer}>
                  {mappedImages.map((image, index) => (
                    <img
                      key={index}
                      className="img-fluid pricing-product-logo"
                      style={{ maxWidth: "75%", marginBottom: "10px" }}
                      src={image}
                      alt={`BidPro Subscription Logo ${index + 1}`}
                    />
                  ))}
                </div>
                <p style={{ fontSize: "0.875rem" }}>
                  Single app subscription to {product}
                </p>
                <h5 className="price">
                  ${price}/{cycle}
                </h5>
                <div className={styles["pricing-features"]}>
                  {features.map((feature, index) => (
                    <p key={index} className={styles["pricing-feature"]}>
                      <i className="fas fa-check"></i> {feature}
                    </p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center mt-3">
          <div className="col-12">
            <p className="text-center">
              Your total will be ${price}/{cycle}
            </p>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <div className="form-check d-flex justify-content-center align-items-center">
              <input
                className="form-check-input me-2"
                type="checkbox"
                id="acceptTerms"
                checked={termsAccepted}
                onChange={handleTermsToggle}
                style={
                  !termsAccepted
                    ? { backgroundColor: "#E8E8E8", borderColor: "black" }
                    : {}
                }
              />
              <label className="form-check-label" htmlFor="acceptTerms">
                I accept the{" "}
                <button
                  className="btn btn-link p-0 m-0"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#modalTerms"
                  style={{
                    verticalAlign: "baseline",
                    paddingBottom: "2px",
                    textDecoration: "none",
                  }}
                >
                  Terms & Conditions
                </button>
              </label>
            </div>
          </div>
        </div>
        {/* Error Alert */}
        {showError && (
          <div
            className={`col-10 col-sm-8 col-md-6 col-lg-5 col-xl-4 ${styles.customAlert} text-center`}
            role="alert"
          >
            Please accept the terms and conditions before continuing.
          </div>
        )}

        <div className="row justify-content-center mt-4">
          <div className="col-12 col-md-8 text-center">
            <button
              className="btn btn-outline-secondary me-2"
              type="button"
              onClick={onCancel}
            >
              Back
            </button>
            <button
              className="btn btn-primary"
              type="button"
              // disabled={!termsAccepted}
              onClick={handleContinueClick}
            >
              Continue to Payment
            </button>
          </div>
        </div>
      </form>

      <div
        className="modal fade"
        id="modalTerms"
        tabIndex="-1"
        aria-labelledby="modalTermsTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalTermsTitle">
                Terms & Conditions
              </h5>
              <button
                className="btn-close"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Payment will be charged at time of purchase.</p>
              <p>
                Your subscription will automatically renew unless the auto-renew
                is turned off at least 24 hours prior to the end of the current
                period.
              </p>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-primary"
                type="button"
                data-bs-dismiss="modal"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ConfirmationMessage.propTypes = {
  product: PropTypes.string.isRequired,
  imageSrc: PropTypes.arrayOf(PropTypes.string).isRequired,
  price: PropTypes.string.isRequired,
  cycle: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  onContinue: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmationMessage;
